let currentEvaluationId: string | null = null;
let currentSessionId: string | null = null;

function generateRandomId(): string {
  return Math.random().toString(36).substring(2, 10);
}

export function generateEvaluationId(): string {
  currentEvaluationId = `eval_${Date.now()}_${generateRandomId()}`;
  return currentEvaluationId;
}

export function getCurrentEvaluationId(): string | null {
  return currentEvaluationId;
}

export function setSessionId(userId: string): void {
  currentSessionId = `session_${userId}_${Date.now()}`;
}

export function getCurrentSessionId(): string | null {
  return currentSessionId;
}

export interface CorrelationContext {
  evaluationId: string | null;
  sessionId: string | null;
}

export function getCorrelationContext(): CorrelationContext {
  return {
    evaluationId: currentEvaluationId,
    sessionId: currentSessionId,
  };
}

export function clearEvaluationId(): void {
  currentEvaluationId = null;
}

export function clearSessionId(): void {
  currentSessionId = null;
}
